module.exports = __webpack_public_path__ + "img/checkbox-circle.08321ed4.svg";